import { render, staticRenderFns } from "./news-style-1.vue?vue&type=template&id=b2d5b6ba&"
import script from "./news-style-1.vue?vue&type=script&lang=js&"
export * from "./news-style-1.vue?vue&type=script&lang=js&"
import style0 from "./news-style-1.vue?vue&type=style&index=0&id=b2d5b6ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports